import type { MainNavRoute, MainPath } from '../types';

import PERMISSIONS from '@snowit/utilities/permissions';

import { makeChildren } from '../utils';

export const PRODUCTS_TABS = [
  'info',
  'owner',
  'config',
  'purchase',
  'terms',
  'images',
  'texts',
  'subproducts',
  'payments',
  'prices',
  'availability',
  'variants',
  'slots',
  'epp',
  'districts_epp',
  'periods',
  'extradata',
  'variant_groups',
  'memberships',
  'social_gallery',
] as const;

export type ProductsTabs = (typeof PRODUCTS_TABS)[number];

export const ProductPath: MainPath = '/products/:id?/:section?/:subId?';

export const ProductRoute: MainNavRoute = {
  path: '/products',
  label: 'routes.products',
  icon: 'products',
  type: 0,
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-23801/127b2e39cbbd79a',
  permissions: [PERMISSIONS.PRODUCTS__LIST],
  children: [
    {
      path: ':id',
      disowned: true,
      permissions: [PERMISSIONS.PRODUCTS__DETAILS],
      children: makeChildren<ProductsTabs>({
        info: { path: 'info' },
        owner: {
          path: 'owner',
          permissions: [PERMISSIONS.PRODUCTS__PARTNER_WEBSHOP],
        },
        config: {
          path: 'config',
          permissions: [PERMISSIONS.PRODUCTS__CONFIG],
        },
        purchase: {
          path: 'purchase',
          permissions: [PERMISSIONS.PRODUCTS__PURCHASE],
        },
        terms: {
          path: 'terms',
          permissions: [PERMISSIONS.PRODUCTS__TERMS],
        },
        variants: {
          path: 'variants',
          permissions: [PERMISSIONS.PRODUCTS__VARIANTS],
          children: [{ path: ':id' }],
        },
        slots: {
          path: 'slots',
          permissions: [PERMISSIONS.PRODUCTS__SLOTS],
          children: [{ path: ':id' }],
        },
        extradata: {
          path: 'extradata',
          permissions: [PERMISSIONS.PRODUCTS__EXTRADATA],
        },
        availability: {
          path: 'availability',
          permissions: [PERMISSIONS.PRODUCTS__AVAILABILITY],
        },
        epp: {
          path: 'epp',
          permissions: [PERMISSIONS.PRODUCTS__EPP],
        },
        districts_epp: {
          path: 'districts_epp',
          permissions: [PERMISSIONS.PRODUCTS__EPP],
        },
        images: {
          path: 'images',
          permissions: [PERMISSIONS.PRODUCTS__IMAGES],
        },
        payments: {
          path: 'payments',
          permissions: [PERMISSIONS.PRODUCTS__PAYMENTS],
        },
        prices: {
          path: 'prices',
          permissions: [PERMISSIONS.PRODUCTS__PRICES],
        },
        subproducts: {
          path: 'subproducts',
          permissions: [PERMISSIONS.PRODUCTS__SUBPRODUCTS],
        },
        periods: {
          path: 'periods',
          permissions: [PERMISSIONS.PRODUCTS__PERIODS],
        },
        texts: {
          path: 'texts',
          permissions: [PERMISSIONS.PRODUCTS__TEXTS],
        },
        variant_groups: {
          path: 'variant_groups',
          permissions: [PERMISSIONS.PRODUCTS__VARIANTS], // check permissions
        },
        memberships: {
          path: 'memberships',
          permissions: [PERMISSIONS.PRODUCTS__VARIANTS],
        },
        social_gallery: {
          path: 'social_gallery',
          permissions: [PERMISSIONS.PRODUCTS__VARIANTS],
        },
      }),
    },
  ],
};
